import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Toaster } from "react-hot-toast";

import { SidebarProvider } from "./contexts/SidebarContext";
import { AuthProvider } from "./contexts/AuthContext";
import AppRoutes from "./routes/AppRoutes";

import "./index.css";
import "./App.css";

const theme = createTheme({
typography: {
fontFamily: "Tajawal, Arial",
},
});
const App: React.FC = () => {
return (
<ThemeProvider theme={theme}>
<Toaster />

  <AuthProvider>
    <SidebarProvider>
      <AppRoutes />
    </SidebarProvider>
  </AuthProvider>
</ThemeProvider>

);
};

export default App;